import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AddPretext from "../AddPretext";
import PretextsList from "../PretextsList";
import RemovePretext from "../RemovePretext";

const getPreTexts = ({ chatsData }) => chatsData.pretexts;

const Pretexts = ({ handleTypeMessage, emojis, chatInputRef }) => {
  const [pretextsContent, setPretextsContent] = useState("pretexts");
  const [deletingPretext, setDeletingPRetext] = useState(null);
  const preTexts = useSelector(getPreTexts);

  useEffect(() => {
    if (preTexts && Array.isArray(preTexts)) {
      setPretextsContent("pretexts");
    }
  }, [preTexts]);

  return (
    <div>
      {pretextsContent === "pretexts" && (
        <PretextsList
          setPretextsContent={setPretextsContent}
          handleTypeMessage={handleTypeMessage}
          setDeletingPretext={setDeletingPRetext}
          chatInputRef={chatInputRef}
        />
      )}
      {pretextsContent === "addPretext" && (
        <AddPretext setPretextsContent={setPretextsContent} emojis={emojis} />
      )}
      {pretextsContent === "removePretext" && (
        <RemovePretext
          setPretextsContent={setPretextsContent}
          deletingPretext={deletingPretext}
          setDeletingPRetext={setDeletingPRetext}
        />
      )}
    </div>
  );
};

export default Pretexts;
